import { render } from "./MbrBottomNav.vue?vue&type=template&id=68e029b1&scoped=true"
import script from "./MbrBottomNav.vue?vue&type=script&lang=js"
export * from "./MbrBottomNav.vue?vue&type=script&lang=js"

import "./MbrBottomNav.vue?vue&type=style&index=0&id=68e029b1&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e029b1"]])

export default __exports__